module.exports = __webpack_public_path__ + "public/images/slider/slide-2.283fcba45c4d25142ba0c1480247c1de.jpg";